import { forwardRef } from "react";
import { Box, TextField as MuiTextField } from "@mui/material";
import type { ProcessedFormField } from "@/types/api/formSchema";
import { CharCounter } from "../components/CharCounter";
import { resolveMaxLength } from "../utils/textLimits";

type Props = {
  field: ProcessedFormField;
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  name: string;
};

export const TextareaField = forwardRef<HTMLTextAreaElement, Props>(
  function TextareaField(
    { field: schemaField, value, onChange, onBlur, name },
    ref,
  ) {
    const current = value ?? "";
    const maxLength = resolveMaxLength(schemaField.maxLength, "TEXTAREA_DEFAULT");

    return (
      <Box>
        <MuiTextField
          inputRef={ref}
          id={name}
          name={name}
          value={current}
          placeholder={
            schemaField.placeholder ?? `Enter ${schemaField.resolvedLabel}`
          }
          disabled={!!schemaField.disabled}
          inputProps={{ maxLength }}
          multiline
          minRows={3}
          onChange={(e) => onChange(e.target.value.slice(0, maxLength))}
          onBlur={onBlur}
          fullWidth
          size="small"
          variant="outlined"
        />
        <CharCounter length={current.length} max={maxLength} />
      </Box>
    );
  },
);
